import isFocusedElement from './is-focused-element';

export default {
  isFocusedElement,
};
